import { Icon } from '@fluentui/react';
import { Utils } from '../../common/views/Utils';
import { FileType, FileCategory } from '../models/PictureModel';
import { usePictureUploadVM } from '../viewmodels/PictureUploadVM';
import { PictureUtils } from './PictureUtilities';

type PictureUploadProps = {
    isEdit: boolean;
    imageUrl?: string;
    fileType: FileType;
    fileCategory: FileCategory;
    size?: any;
    onAction: (file?: File) => void;
}

export default function PictureUpload({
    isEdit, imageUrl, fileType, fileCategory, size, onAction
}: PictureUploadProps) {
    const vm = usePictureUploadVM(imageUrl ?? "", onAction);

    const display = isEdit ? "none" : "normal";

    return <div className="pv-10">
        <div style={{ width: "100% !important" }}>
            {!Utils.isNullOrEmpty(vm.displayPicture) && <>
                <Icon iconName="StatusCircleErrorX"
                    onClick={vm.clearFileInput}
                    className="icon delete-cart" />
            </>}

            {PictureUtils.createImageElement2(
                fileType,
                vm.displayPicture,
                fileCategory,
                size,
                () => { }
            )}
        </div>

        <div className="pt-10 pb-5 center">
            <input
                id="uploadFile"
                name="uploadFile"
                type="file"
                onChange={(e) => vm.onLoadFile(e.target)}
                style={{ display: display }}
            />
        </div>
    </div>;
}